// import ApiServices from "@/services/ApiServices";

export default {
  data: () => ({
    //favoriteCompanyIds: [1, 2, 4, 8], //alphabetical by company name, Alcon, B&L, Cooper, J&J
  }),
  computed: {
    clCompanies: function () {
      return this.$store.state.clCompanies;
    },
    favoriteCompanies: function () {
      return this.companiesForIds(this.favoriteCompanyIds, this.clCompanies);
    },
    allCompanyIds: function () {
      return this.favoriteCompanyIds.concat(this.nonFavoriteCompanyIds);
    },
    mainCompanyIds: function () {
      return this.$store.state.mainCompanyIds;
    },
    favoriteCompanyIds: function () {
      return this.$store.state.favoriteCompanyIds;
    },
    nonFavoriteCompanyIds: function () {
      return this.$store.getters.nonFavoriteCompanyIds;
    },
    nonFavoriteCompanies: function () {
      return this.companiesForIds(this.nonFavoriteCompanyIds, this.clCompanies);
    },
    companyArrays: function () {
      let rtn = {};
      rtn.main = this.mainCompanyIds;
      rtn.favorites = this.favoriteCompanyIds;
      rtn.nonFavorites = this.nonFavoriteCompanyIds;
      return rtn;
    },
    companyLists: function () {
      let rtn = {};
      Object.entries(this.companyArrays).forEach(([key, value]) => {
        let joined = value.join(",");
        rtn[key] = joined;
      });
      return rtn;
    },
    // order companies with big 4 first, then alphabetically
    // returns company ids
    logicalCompanyOrder: function () {
      if (!this.clCompanies) return null;
      let favsSorted = this.favoriteCompanyIds.sort((a, b) => {
        let aName = this.companyObjForId(a).name;
        let bName = this.companyObjForId(b).name;
        let compare = aName.localeCompare(bName);
        // console.log(aName, bName, compare);
        return compare;
      });
      let nonFavsSorted = this.nonFavoriteCompanyIds.sort((a, b) => {
        let aName = this.companyObjForId(a).name;
        let bName = this.companyObjForId(b).name;
        let compare = aName.localeCompare(bName);
        // console.log(aName, bName, compare);
        return compare;
      });
      let combined = [...favsSorted, ...nonFavsSorted];
      // combined.forEach((id) => {
      //   console.log(id, this.companyObjForId(id).name);
      // });
      return combined;
    },
  },
  methods: {
    companyIdForSlug(slug) {
      let id = null;
      if (!this.clCompanies) return null;
      this.clCompanies.forEach((company) => {
        if (slug == company.slug) id = company.id; // can't break with forEach?
      });
      return id;
    },
    getCompanyParamString(company) {
      let rtn = "";
      if (!isNaN(company)) {
        rtn = "comp_id=" + rtn;
      } else if (company.toUpperCase() == "MAIN") {
        rtn = "comp_id[]=" + this.mainCompanyIds.join(",");
      } else if (company.toUpperCase() == "FAVORITES") {
        rtn = "comp_id[]=" + this.favoriteCompanyIds.join(",");
      } else {
        let id = this.companyIdForSlug(company);
        if (id) {
          rtn = "comp_id=" + id;
        } else {
          rtn = "comp_slug=" + company.toLowerCase();
        }
      }
      return rtn;
    },

    // returns an array of company objects in alphabetical order
    companiesForIds(idArray, clCompanies) {
      //console.log("idArray", idArray);
      if (!clCompanies) return null;
      let rtn = [];
      let companyIndicesById = this.$store.getters.companyIndicesById;
      idArray.forEach((id) => {
        let index = companyIndicesById[`${id}`];
        let compObj = clCompanies[parseInt(index)];
        if (index || index === 0) rtn.push(compObj);
      });
      // sort by favorite, then alphabetize by company
      let favs = this.$store.state.favoriteCompanyIds;
      rtn.sort((a, b) => {
        favs.includes(parseInt(b.id)) - favs.includes(parseInt(b.id)) ||
          b.name - a.name;
      });
      return rtn;
    },
    companyObjForId: function (id) {
      if (!this.clCompanies) return null;
      let companyIndex = this.$store.getters.companyIndicesById[id];
      let companyObj = this.clCompanies[companyIndex];
      return companyObj ? companyObj : null;
    },
    logoForCompanyId: function (id) {
      let companyObj = this.companyObjForId(id);
      return companyObj?.image;
    },
    nameForCompanyId(id) {
      let companyObj = this.companyObjForId(id);
      return companyObj?.name;
    },
  },
  mounted: function () {
    // if (!this.$store || !this.clCompanies) this.callClCompanyApi();
  },
};
